import { render, staticRenderFns } from "./browse-list-filter.component.vue?vue&type=template&id=445944ec"
import script from "./browse-list-filter.component.vue?vue&type=script&lang=ts"
export * from "./browse-list-filter.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports